import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';

/**
 * Componente para mostrar la información básica del cliente
 */
const InformacionCliente = ({ idCliente, nombre, apellidos, esRecompra }) => {
    // Si no hay información del cliente, no renderizar nada
    if (!idCliente || !nombre) {
        return null;
    }

    return (
        <div className="mb-3 mt-4 mb-md-0 fs-1">
            <b>
                {idCliente} - {nombre} {apellidos} -
            </b>
            <SoftBadge
                pill
                bg={esRecompra ? 'primary' : 'success'}
                className="fs--1 ms-2"
            >
                <span className="mb-0">
                    {esRecompra ? 'Re-compra' : 'Primer Compra'}
                </span>
                <FontAwesomeIcon
                    icon={classNames({ check: true })}
                    transform="shrink-2"
                    className="ms-1"
                />
            </SoftBadge>
        </div>
    );
};

InformacionCliente.propTypes = {
    idCliente: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    nombre: PropTypes.string,
    apellidos: PropTypes.string,
    esRecompra: PropTypes.bool
};

InformacionCliente.defaultProps = {
    idCliente: null,
    nombre: '',
    apellidos: '',
    esRecompra: false
};

export default InformacionCliente;
